import { ThemeUIStyleObject } from 'theme-ui';

export const containerStyles: ThemeUIStyleObject = {
  alignItems: ['stretch', 'center'],
  justifyContent: 'start',
  flexDirection: ['column', 'row'],
  gap: ['0.5rem', '1.5rem'],
  padding: ['0.75rem', '0.5rem 1rem'],
  borderBottom: '1px solid',
  borderColor: 'neutral/200',
  bg: 'neutral/000',

  '@media (min-width: 768px)': {
    '& > *:nth-of-type(2)': {
      flexShrink: 0,
      minWidth: '5rem',
    },
    '& > *:nth-of-type(3)': {
      flexShrink: 0,
      minWidth: '5rem',
    },
    '& > *:nth-of-type(4)': {
      flexShrink: 0,
      width: '15rem',
    },
    '& > *:nth-of-type(5)': {
      flexShrink: 0,
      minWidth: '7rem',
    },
  },
};

export const containerErrorStyles: ThemeUIStyleObject = {
  ...containerStyles,
  bg: 'error/100',
};

export const iconTextSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: ['0.5rem', '0.75rem'],
  flex: [0, 1],
  width: ['100%', 'auto'],
  minWidth: 0,
  paddingLeft: ['0.25rem', '0.5rem'],
};

export const iconTextInnerStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: ['0.5rem', '0.75rem'],
  flex: 1,
  minWidth: 0,
};

export const itemNameWrapperStyles: ThemeUIStyleObject = {
  flex: 1,
  minWidth: 0,
  fontSize: ['0.875rem', '1rem'],
};

export const numberedIconStyles: ThemeUIStyleObject = {
  width: '1rem',
  height: '1rem',
  borderRadius: '50%',
  bg: 'neutral/200',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.75rem',
  fontWeight: 600,
  color: 'neutral/700',
  flexShrink: 0,
};

export const progressSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: ['0.5rem', '0.25rem'],
  width: ['100%', '15rem'],
};

export const progressBarContainerStyles: ThemeUIStyleObject = {
  flex: 1,
  width: '100%',
  minWidth: 0,
};

export const progressTextStyles: ThemeUIStyleObject = {
  textAlign: 'right',
  width: ['2.5rem', '2.5rem'],
  flexShrink: 0,
};

export const progressInputStyles: ThemeUIStyleObject = {
  width: '4.5rem',
  flexShrink: 0,

  '& input': {
    width: '100%',
    maxWidth: '4.5rem',
  },
};

export const progressTextMobileStyles: ThemeUIStyleObject = {
  display: ['block', 'none'],
  fontSize: '0.875rem',
};

export const progressInputDesktopStyles: ThemeUIStyleObject = {
  display: ['none', 'block'],
};

export const progressTextNonEditableStyles: ThemeUIStyleObject = {
  fontSize: ['0.875rem', '1rem'],
};

export const selectButtonWrapperStyles: ThemeUIStyleObject = {
  flexShrink: 0,
  minWidth: ['5rem', '7rem'],
};

export const actionButtonsStyles: ThemeUIStyleObject = {
  gap: ['0.25rem', '0.5rem'],
  alignItems: 'center',
};
